// also use for product versions on CT Product detail page
const accordionHeaders = document.querySelectorAll(
  '.accordion-item__button, .product__versions-header',
);

accordionHeaders.forEach((button) => {
  button.addEventListener('click', ({ currentTarget }) => {
    currentTarget.setAttribute(
      'aria-expanded',
      !(currentTarget.getAttribute('aria-expanded') === 'true'),
    );

    // deselect Expand all product versions checkbox
    const checkbox = currentTarget.parentNode.querySelector(
      '.product__versions-checkbox',
    );
    if (checkbox != null) {
      checkbox.checked = false;
    }
  });
});
